export default "__VITE_ASSET__20592942__"